/* tiny shared helpers — used by engine logic and the UI */
export const clone = (o) => JSON.parse(JSON.stringify(o));
export const signed = (n) => (n > 0 ? "+" : "") + n;

/* stable identifier for a shoe — doubles as the database row id */
export function makeShoeId() {
  if (globalThis.crypto?.randomUUID) return globalThis.crypto.randomUUID();
  return "shoe-" + Date.now() + "-" + Math.floor(Math.random() * 1e9);
}
export const fmt = (n) => (Number.isInteger(n) ? n.toLocaleString() : n.toFixed(2));
